import Draggable from "@/lib/Draggable";
import { DRAG_HEADER } from "@/lib/reactGridLayout/dndConstants";
import { ICellRendererParams } from "ag-grid-enterprise";

// Makes the Trade Creation "Security" cell draggable so a block can be dragged out of the
// grid and dropped onto the Swap Curve widget. The drag payload carries the block id
// (header = "Block") while the user sees the security name (label); the receiving widget
// looks the block up by id to validate it is a swap.
const CreationSecurityCellRenderer = ({
  data,
}: Partial<ICellRendererParams>) => {
  if (!data) return null;

  const securityName = data.securityName ?? "";

  return (
    <div
      data-testid="CreationSecurityCellContainer"
      id="CreationSecurityCellContainer"
    >
      <Draggable
        id={`block-${data.id}`}
        value={String(data.id)}
        label={securityName}
        header={DRAG_HEADER.BLOCK}
      >
        <div
          className="overflow-hidden text-ellipsis"
          data-testid="draggableBlockSecurity"
        >
          {securityName}
        </div>
      </Draggable>
    </div>
  );
};

export default CreationSecurityCellRenderer;
